"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ERROR_DESCRIPTION = exports.ERROR_CODE = exports.P2_VALUES = exports.PAYLOAD_TYPE = exports.INS = exports.APP_KEY = exports.CHUNK_SIZE = exports.CLA = void 0;
exports.CLA = 0x55;
exports.CHUNK_SIZE = 250;
exports.APP_KEY = "CSM";
exports.INS = {
    GET_VERSION: 0x00,
    INS_PUBLIC_KEY_SECP256K1: 0x01,
    SIGN_SECP256K1: 0x02,
    GET_ADDR_SECP256K1: 0x04,
};
exports.PAYLOAD_TYPE = {
    INIT: 0x00,
    ADD: 0x01,
    LAST: 0x02,
};
exports.P2_VALUES = {
    JSON: 0x0,
    TEXTUAL: 0x1,
};
exports.ERROR_CODE = {
    NoError: 0x9000,
};
exports.ERROR_DESCRIPTION = {
    1: "U2F: Unknown",
    2: "U2F: Bad request",
    3: "U2F: Configuration unsupported",
    4: "U2F: Device Ineligible",
    5: "U2F: Timeout",
    14: "Timeout",
    0x9000: "No errors",
    0x9001: "Device is busy",
    0x6802: "Error deriving keys",
    0x6400: "Execution Error",
    0x6700: "Wrong Length",
    0x6982: "Empty Buffer",
    0x6983: "Output buffer too small",
    0x6984: "Data is invalid",
    0x6985: "Conditions not satisfied",
    0x6986: "Transaction rejected",
    0x6a80: "Bad key handle",
    0x6b00: "Invalid P1/P2",
    0x6d00: "Instruction not supported",
    0x6e00: "App does not seem to be open",
    0x6f00: "Unknown error",
    0x6f01: "Sign/verify error",
};
//# sourceMappingURL=constants.js.map